export const ORG_STORAGE_KEY = 'selected_organization_id';
export const SITE_STORAGE_KEY = 'selected_site_collection_id';

/**
 * Returns initial organization ID based on role permissions:
 * - System Administrator: restores from localStorage, or defaults to empty (prompting selection).
 * - All other roles: strictly locked to session fallbackOrgId.
 */
export function getInitialOrgId(isSystemAdmin, fallbackOrgId = '') {
  if (isSystemAdmin) {
    try {
      return localStorage.getItem(ORG_STORAGE_KEY) || '';
    } catch {
      return '';
    }
  }
  return fallbackOrgId || '';
}

/**
 * Persists organization selection into storage for System Administrators.
 * Also clears the selected site collection from storage to prevent cross-org stale state.
 */
export function persistOrgSelection(isSystemAdmin, orgId) {
  if (!isSystemAdmin) return;
  try {
    if (orgId) {
      localStorage.setItem(ORG_STORAGE_KEY, orgId);
    } else {
      localStorage.removeItem(ORG_STORAGE_KEY);
    }
    localStorage.removeItem(SITE_STORAGE_KEY);
  } catch {
    // Ignore private browsing storage restrictions
  }
}

/**
 * Returns initial site collection ID from storage for any role.
 */
export function getInitialSiteId() {
  try {
    return localStorage.getItem(SITE_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

/**
 * Persists site collection selection into storage for any role.
 */
export function persistSiteSelection(siteId) {
  try {
    if (siteId) {
      localStorage.setItem(SITE_STORAGE_KEY, siteId);
    } else {
      localStorage.removeItem(SITE_STORAGE_KEY);
    }
  } catch {
    // Ignore private browsing storage restrictions
  }
}

/**
 * Validates a candidate ID against a list of entities (e.g. organizations or site collections).
 * If valid, retains it. If invalid, clears storage and returns empty string.
 */
export function validateAndReconcileSelection(list, candidateId, storageKey) {
  const items = Array.isArray(list) ? list : [];
  const candidate = candidateId || (() => {
    try {
      return storageKey ? (localStorage.getItem(storageKey) || '') : '';
    } catch {
      return '';
    }
  })();

  if (candidate && items.some(item => String(item?.id) === String(candidate))) {
    return candidate;
  }

  if (candidate && storageKey) {
    try {
      localStorage.removeItem(storageKey);
    } catch {
      // Ignore
    }
  }

  return '';
}
